export const monthMap = {
    Enero: "01",
    Febrero: "02",
    Marzo: "03",
    Abril: "04",
    Mayo: "05",
    Junio: "06",
    Julio: "07",
    Agosto: "08",
    Septiembre: "09",
    Octubre: "10",
    Noviembre: "11",
    Diciembre: "12"
};
export const months = [
    "01/24",
    "02/24",
    "03/24",
    "04/24",
    "05/24",
    "06/24",
    "07/24",
    "08/24",
    "09/24",
    "10/24",
    "11/24",
    "12/24",
    "01/25",
    "02/25",
    "03/25",
    "04/25",
    "05/25",
    "06/25",
    "07/25",
    "08/25",
    "09/25",
    "10/25",
    "11/25",
    "12/25",
    "01/26",
    "02/26",
    "03/26",
    "04/26",
    "05/26",
    "06/26",
    "07/26",
    "08/26",
    "09/26",
    "10/26",
    "11/26",
    "12/26",
];
export const series = [
    { month: "Enero", value: 30 },
    { month: "Febrero", value: 50 },
    { month: "Marzo", value: 20 },
  ];
export const dataPierChart = [
    { id: 0, value: 10, label: 'series A' },
    { id: 1, value: 15, label: 'series B' },
    { id: 2, value: 20, label: 'series C' },
    { id: 3, value: 10, label: 'series D' },
    { id: 4, value: 15, label: 'series E' },
    { id: 5, value: 20, label: 'series F' },
    { id: 6, value: 10, label: 'series G' },
    { id: 7, value: 15, label: 'series H' },
    { id: 8, value: 20, label: 'series I' },
    { id: 9, value: 10, label: 'series J' },
    { id: 10, value: 15, label: 'series K' },
    { id: 11, value: 20, label: 'series L' },
    { id: 12, value: 10, label: 'series M' },
    { id: 13, value: 15, label: 'series N' },
    { id: 14, value: 20, label: 'series O' },
    { id: 15, value: 10, label: 'series P' },
    { id: 16, value: 15, label: 'series Q' },
    { id: 17, value: 20, label: 'series R' },
    { id: 18, value: 10, label: 'series S' },
    { id: 19, value: 15, label: 'series T' },
    { id: 20, value: 20, label: 'series U' },
    // { id: 21, value: 10, label: 'series V' },
    // { id: 22, value: 15, label: 'series W' },
    // { id: 23, value: 20, label: 'series X' },
    // { id: 24, value: 10, label: 'series Y' },
    // { id: 25, value: 15, label: 'series Z' },
];
export const colorsPierChart = [
    '#4caf50', '#2196f3', '#ff9800', '#e91e63', '#9c27b0',
    '#00bcd4', '#cddc39', '#ff5722', '#3f51b5', '#8bc34a',
    '#795548', '#607d8b', '#f44336', '#673ab7', '#ffc107',
    '#009688', '#e0e0e0', '#a1887f', '#d32f2f', '#1976d2',
    '#388e3c', '#fbc02d', '#7b1fa2', '#5d4037', '#0288d1',
    '#b71c1c', '#1a237e', '#33691e', '#ff6f00', '#6d4c41',
    '#00acc1', '#8e24aa', '#c2185b', '#689f38', '#ff7043',
    '#3949ab', '#00796b', '#fdd835', '#512da8', '#d84315',
    '#263238', '#aed581', '#81d4fa', '#ef5350', '#9575cd',
    '#dce775', '#4dd0e1', '#ffb74d', '#7986cb', '#a5d6a7'
];

export const seriesLineChart = [
    "01/24",
    "02/24",
    "03/24",
    "04/24",
    "05/24",
    "06/24",
    "07/24",
    "08/24",
    "09/24",
    "10/24",
    "11/24",
    "12/24",
    "01/25",
    "02/25",
    "03/25",
    "04/25",
    "05/25",
    "06/25",
    "07/25",
    "08/25",
    "09/25",
    "10/25",
    "11/25",
    "12/25",
    "01/26",
    "02/26",
    "03/26",
    "04/26",
    "05/26",
    "06/26",
    "07/26",
    "08/26",
    "09/26",
    "10/26",
    "11/26",
    "12/26",
];;
export const seriesTiempoLineChart = [[10, 20, 35, 50,],[10, 20, 35, 50,],[10, 20, 35, 50,],[10, 20, 35, 50,],[10, 20, 35, 50,],[10, 20, 35, 50,],[10, 20, 35, 50,],[10, 20, 35, 50,]];
